import { render, staticRenderFns } from "./initDevice.vue?vue&type=template&id=97bbd93a&scoped=true"
import script from "./initDevice.vue?vue&type=script&lang=js"
export * from "./initDevice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97bbd93a",
  null
  
)

export default component.exports